/**
 * routes 不受权限约束的路由
 * hideInMenu 控制不在菜单栏显示的路由，不受权限约束的子路由，如：增删改查等
 * 路由name设置与统一门户权限设置的字段对应（用于控制页面级别权限）
 */

export const routes = [
  {
    path: '/',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import('_v/style-center/login')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '登录'
    },
    component: () => import('_v/style-center/login')
  },
  {
    path: '/link',
    name: 'link',
    meta: {
      title: '其他链接'
    },
    component: () => import('_v/style-center/link')
  },
  {
    path: '/authorize',
    component: () => import('@/views/AuthRedirect.vue'),
    meta: { skipAuthCheck: true } // 跳过全局路由守卫检查
  },
  {
    path: '/loginBack',
    component: () => import('@/views/loginBack.vue')
  },
  {
    path: '/external_links',
    name: 'external_links',
    meta: {
      title: '外部链接'
    },
    component: () => import('_v/external_links')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/layouts/base'),
    redirect: '/indexHome',
    meta: {
      title: '首页'
    },
    children: [
      {
        path: '/indexHome',
        name: 'home',
        component: () => import('_v/home/indexHome'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/center',
        name: 'center',
        meta: {
          title: '个人中心'
        },
        component: () => import('_v/home/center')
      },
      {
        path: '/headquartersCenter',
        name: 'headquartersCenter',
        meta: {
          title: '个人中心'
        },
        component: () => import('_v/home/headquartersCenter')
      },
      {
        path: '/assistant',
        name: 'assistant',
        meta: {
          title: 'AI助手'
        },
        component: () => import('_v/home/assistant')
      },
      {
        path: '/rulesList',
        name: 'rulesList',
        meta: {
          title: '规章制度'
        },
        component: () => import('_v/home/modules/RulesList')
      },
      {
        path: '/journalismList',
        name: 'journalismList',
        meta: {
          title: '新闻公告'
        },
        component: () => import('_v/home/modules/JournalismList')
      }
    ]
  },
  {
    path: '/autoLoginDD',
    name: 'autoLoginDD',
    meta: {
      title: '统一门户'
    },
    component: () => import('_v/autoLoginDD')
  },
  {
    path: '/autoLoginPC',
    name: 'autoLoginPC',
    meta: {
      title: '统一门户'
    },
    component: () => import('_v/autoLoginPC')
  },
  {
    path: '/phoneApp',
    name: 'phoneApp',
    meta: {
      title: '统一门户'
    },
    component: () => import('_v/phoneApp')
  },
  {
    path: '/certificates',
    name: 'certificates',
    meta: {
      title: '证件提醒'
    },
    component: () => import('_v/certificates')
  },
  {
    path: '/changePassword',
    name: 'changePassword',
    meta: {
      title: '修改密码'
    },
    component: () => import('_v/changePassword')
  },
  {
    path: '/mobileAssistant',
    name: 'mobileAssistant',
    meta: {
      title: 'AI助手'
    },
    component: () => import('_v/mobileAssistant')
  },
  {
    path: '/computerAssistant',
    name: 'computerAssistant',
    meta: {
      title: 'PC_AI助手'
    },
    component: () => import('_v/computerAssistant')
  },
  {
    path: '/home_old',
    name: 'home_old',
    meta: {
      title: '首页'
    },
    component: () => import('_v/home_old')
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    meta: {
      hideInMenu: true,
      notCache: true,
      title: '重置密码'
    },
    component: () => import('_v/resetPassword')
  },
  {
    path: '/scanerror',
    name: 'error_scanerror',
    meta: {
      title: '错误页面',
      hideInMenu: true
    },
    component: () => import('_v/error-page/scanerror.vue')
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('_v/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('_v/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('_v/error-page/404.vue')
  }
]
